import { IoIosArrowDropleft } from 'react-icons/io';
import { Section } from '../components/Section';
import type { IOrder } from '@/types';
import { Box, Button, Container, Flex, Heading, Icon, Text } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { DocumentInfoBox } from '../components';

import { useFetchDocs } from '@/hooks';

export const DocumentDetail = (): JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();

  const { docs } = useFetchDocs();

  const documentInfo: IOrder | undefined = docs?.find((doc) => doc.id === params.id);

  const hardcodedWords =
    documentInfo?.type === 'shipment'
      ? {
          heading: 'La tua spedizione',
          title: 'Spedizione',
          of: 'partita il',
          expiryDate: documentInfo.trackingMbe,
        }
      : {
          heading: 'Il tuo preventivo',
          title: 'Preventivo',
          of: 'del',
          expiryDate: `Scadenza ${documentInfo?.quoteExpiryDate ?? ''} `,
        };

  return (
    <Box bg="brand.sand" paddingBottom={16} paddingTop={2} w="full">
      <Container maxW="8xl" px={{ base: 4, md: 8 }} py={{ base: 8, lg: 0 }}>
        <Button color="brand.red.light" px={2} onClick={(): void => navigate(-1)}>
          <Icon as={IoIosArrowDropleft} color="brand.red.light" h={10} m={0} w={10} />
        </Button>
        <Section id="quotes" title={hardcodedWords.heading}>
          <Container bg="white" minW="100%" px={44} py={16}>
            {/* <h2>{documentInfo?.customer.firstName}</h2> */}
            <Flex alignItems="center" justifyContent="space-between">
              <Flex direction="column">
                <Heading as="h2" fontSize="h2.md" fontWeight="normal" lineHeight="taller">
                  {hardcodedWords.title} {documentInfo?.shipmentId}
                </Heading>
                <Text>
                  {hardcodedWords.of} {documentInfo?.createdAt}
                </Text>
              </Flex>
              <Text>
                {hardcodedWords.expiryDate?.toUpperCase()} {documentInfo?.quoteExpiryDate}
              </Text>
            </Flex>
            <DocumentInfoBox shipment={documentInfo} />
          </Container>
        </Section>
      </Container>
    </Box>
  );
};
